import menu from '@/content/menu.json';
import Menu from './Menu';

export default function FooterMenuCompany() {
  return <Menu title={menu.company.title} items={menu.company.items} />;
}
